/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Group_Description_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Group Description" |
*
* @param {Team_Manager_Group_Description_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_group_description_placeholder = /** @type {((inputs?: Team_Manager_Group_Description_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Group_Description_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Description du groupe")
	if (locale === "de") return /** @type {LocalizedString} */ ("Gruppenbeschreibung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Descrizione del gruppo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Описание группы")
	if (locale === "es") return /** @type {LocalizedString} */ ("Descripción del grupo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("组描述")
	if (locale === "ja") return /** @type {LocalizedString} */ ("グループの説明")
	if (locale === "hi") return /** @type {LocalizedString} */ ("समूह विवरण")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Descrição do grupo")
	return /** @type {LocalizedString} */ ("Group Description")
});